import Vue from 'vue'
import VueScrollReveal from 'vue-scroll-reveal';
Vue.use(VueScrollReveal);
